import { isArrayLikeObject } from 'lodash';
import React from 'react';
import MaskedInput from 'react-text-mask';
import DebounceTextField from '../DebounceTextField';

const regexPatterns = ['\\d', '\\w', '\\s', '\\D', '\\W', '\\b', '\\B'];

function normalizePH(num) {
  // TODO: fix 9 6 gets skipped

  return num;
  if (!num || (typeof num !== 'string' && typeof num !== 'int')) return num;

  num = num.trim();

  if (num.startsWith('+63')) return num.slice(3); // ensure exactly 10 digits after +63
  if (num.startsWith('09')) return num.slice(1);
  if (num.startsWith('63')) return num.slice(2);

  return num;
}

function convertToRegex(str) {
  try {
    return regexPatterns.includes(str) ? new RegExp(str) : str;
  } catch (e) {
    return str;
  }
}

function generateMask(mask) {
  if (!mask && !isArrayLikeObject(mask)) return false;

  return mask.map(convertToRegex);
}

const TextMask = ({ inputRef, ...other }) => {
  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={other.mask}
      placeholderChar="_"
      keepCharPositions
      showMask
      guide
    />
  );
};

const CustomMaskedInput = ({ data, onChangeField }) => {
  const mask = generateMask(data?.mask);
  const normalizedValue = normalizePH(data?.value);
  return (
    <DebounceTextField
      label={data?.label || data?.caption || ''}
      variant="outlined"
      InputProps={{
        inputComponent: TextMask
      }}
      onChange={onChangeField}
      value={normalizedValue || ''}
      inputProps={{ mask }}
      InputLabelProps={{
        shrink: true
      }}
      name={data.fld}
      {...data.rest}
    />
  );
};

export default CustomMaskedInput;
